'use strict';



const confirmFormSubmit = require('./confirm-form-submit');



const confirmLoanpartDecisions = $form => confirmFormSubmit($form, $form => {

    return `
        <h1 class='[  c-heading  c-heading--dark  ]  u-beta'>I understand by selecting OK that</h1>
        <p>1. My saved decision cannot be amended</p>
        <p>2. That my loan parts may take 72 hours to be removed from "My Loans" section of my account (if applicable)</p>`;

});



module.exports = confirmLoanpartDecisions;
